const DAY_MS = 24 * 60 * 60 * 1000;
export const LINNWORKS_API_MAX_LOOKBACK_MS = 35 * DAY_MS;
export const LINNWORKS_FORWARD_SYNC_INITIAL_LOOKBACK_MS = 28 * DAY_MS;
export const LINNWORKS_SYNC_OVERLAP_MS = 60 * 1000;
export const LINNWORKS_INSTALL_TRACKING_PURPOSE = "redo:linnworks-install";

export const LinnworksLocality = { EU: "EU", US: "US", AS: "AS" } as const;
export type LinnworksLocality =
  (typeof LinnworksLocality)[keyof typeof LinnworksLocality];
